export default __webpack_public_path__ + "static/media/compact-disc.69be18ee.png";